import { useQuery } from "@apollo/client/react";
import { IdentifierTypesDocument } from "@repo/graphql/documents/fiscal/query.generated";
import { IdentifierTypeEnum } from "@repo/graphql/gql/graphql";
import { useMemo } from "react";
import { filterIdentifierOptions, IdentifierTypeOption } from "./logic";

const NO_OPTIONS: IdentifierTypeOption[] = [];

/**
 * The document types a country accepts, tax-ID type first. Pass a stable
 * `allowedTypes` (a module constant such as `TAX_ID_TYPES`).
 */
export function useIdentifierTypes(
  countryCode: string | null | undefined,
  allowedTypes?: readonly IdentifierTypeEnum[],
) {
  const { data, loading } = useQuery(IdentifierTypesDocument, {
    variables: { countryCode: countryCode ?? "" },
    skip: !countryCode,
  });
  const options = useMemo(
    () =>
      filterIdentifierOptions(
        data?.fiscal.identifierTypes ?? NO_OPTIONS,
        allowedTypes,
      ),
    [data, allowedTypes],
  );
  return { options, loading };
}
